import React, { useEffect, useState } from 'react';
import { db } from '../db/firebase.js';
import { collection, getDocs, query, orderBy, limit } from 'firebase/firestore';

const AdminFloor = () => {
    const [floorData, setFloorData] = useState([]);
    const [docDate, setDocDate] = useState(null);
    const [loading, setLoading] = useState(true);
    const [mythicNames, setMythicNames] = useState({});

    useEffect(() => {
        const load = async () => {
            try {
                const [floorSnap, nftsSnap] = await Promise.all([
                    getDocs(query(collection(db, 'floor'), orderBy('__name__', 'desc'), limit(1))),
                    getDocs(collection(db, 'nfts')),
                ]);

                // Build rank → name map (take first NFT per rank)
                const names = {};
                nftsSnap.docs.forEach(d => {
                    const nft = d.data();
                    if (nft.rank != null && !names[nft.rank]) {
                        names[nft.rank] = nft.name;
                    }
                });
                setMythicNames(names);

                if (!floorSnap.empty) {
                    const latestDoc = floorSnap.docs[0];
                    const raw = latestDoc.id; // YYYYMMDD
                    setDocDate(`${raw.slice(0, 4)}-${raw.slice(4, 6)}-${raw.slice(6, 8)}`);

                    const data = latestDoc.data();
                    const rows = Object.entries(data)
                        .map(([rank, price]) => ({ rank: Number(rank), price }))
                        .filter(r => !isNaN(r.rank))
                        .sort((a, b) => a.rank - b.rank);
                    setFloorData(rows);
                }
            } catch (err) {
                console.error('AdminFloor load error:', err);
            } finally {
                setLoading(false);
            }
        };
        load();
    }, []);

    if (loading) return <div className="admin-loading">Loading floor prices...</div>;

    return (
        <div className="admin-section">
            <div className="admin-floor-header">
                <h2 className="admin-section-title" style={{ borderBottom: 'none', paddingBottom: 0 }}>
                    Floor Prices
                </h2>
                {docDate && (
                    <span className="admin-floor-date">Last updated: {docDate}</span>
                )}
            </div>

            {floorData.length === 0 ? (
                <p className="admin-muted">No floor price data found. Run the cron to populate it.</p>
            ) : (
                <div className="admin-table-wrapper">
                    <table className="admin-table">
                        <thead>
                            <tr>
                                <th>Rank</th>
                                <th>Mythic Name</th>
                                <th>Floor Price</th>
                            </tr>
                        </thead>
                        <tbody>
                            {floorData.map(({ rank, price }) => (
                                <tr key={rank}>
                                    <td className="admin-td-num">{rank}</td>
                                    <td>{mythicNames[rank] || <span className="admin-muted">—</span>}</td>
                                    <td>
                                        {price && price !== '-'
                                            ? <strong style={{ color: '#ffd50d' }}>{price}</strong>
                                            : <span className="admin-muted">No listing</span>
                                        }
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    );
};

export default AdminFloor;
